import { Link } from "react-router-dom";
import ERP_Logo from "../../img/erp_logo.png";
import jwtDecode from "jwt-decode";
import { logout } from "../../helpers/functions/logout";
import { useHistory } from "react-router-dom";
import { useSidebar } from "./SidebarContext";
import menuIcon from "../../img/icons8-menu.svg";
import { ToastContainer } from "react-toastify";

function Navbar() {
  const token = localStorage.getItem("refreshToken");
  const history = useHistory();
  const { openSidebar } = useSidebar();
  let user = null;

  if (token) {
    try {
      user = jwtDecode(token);
    } catch (error) {
      console.error("Invalid token", error);
      user = {};
    }
  }

  const handleStartTour = () => {
    // Dispatch custom event to trigger sidebar tour
    const event = new CustomEvent("startSidebarTour");
    window.dispatchEvent(event);
  };

  return (
    <>
      <ToastContainer />
      <nav
        className="navbar navbar-expand-lg bg-glass mx-2 mt-2 rounded-2"
        style={{ zIndex: 1054 }}
      >
        <div className="container-fluid">
          {/* Left side - Menu icon (mobile/tablet only) + Logo + Home link (desktop only) */}
          <div className="d-flex align-items-center">
            {/* Menu icon for mobile and tablet (hidden on lg and up) */}
            <button
              className="hamburger-menu-icon btn btn-link p-0 me-2 d-lg-none"
              onClick={openSidebar}
              style={{ border: "none", background: "transparent" }}
            >
              <img
                src={menuIcon}
                alt="menu"
                style={{ width: "32px", height: "32px" }}
              />
            </button>

            {/* Logo with responsive sizing */}
            <Link className="navbar-brand me-3" to="/">
              <img
                src={ERP_Logo}
                alt="logo"
                className="d-none d-md-block"
                style={{ width: "88px", height: "auto" }}
              />
              <img
                src={ERP_Logo}
                alt="logo"
                className="d-block d-md-none"
                style={{ width: "66px", height: "auto" }}
              />
            </Link>

            {/* Home link for desktop only */}
            <ul className="navbar-nav d-none d-lg-flex">
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/">
                  Home
                </Link>
              </li>
            </ul>
          </div>

          {/* Right side - User menu */}
          <ul className="navbar-nav ms-auto d-flex flex-row align-items-center gap-2">
            {user ? (
              <>
                {/* Home icon for mobile/tablet only */}
                <li className="nav-item d-lg-none">
                  <Link className="nav-link active" aria-current="page" to="/">
                    <i className="bi bi-house-fill"></i>
                  </Link>
                </li>

                {/* User dropdown */}

                {/* Tour Guide Button */}
                {/* <li className="nav-item">
                  <button
                    className="tour-guide-button btn btn-link nav-link p-0"
                    onClick={handleStartTour}
                    title="Start Dashboard Tour"
                    style={{
                      transition: "all 0.2s ease",
                      cursor: "pointer",
                    }}
                  >
                    <i className="bi bi-question-circle fs-5"></i>
                  </button>
                </li> */}
              </>
            ) : (
              <li className="nav-item">
                <Link
                  className="nav-link text-nowrap"
                  to="/sign-in"
                  style={{
                    transition: "all 0.2s ease",
                    cursor: "pointer",
                  }}
                >
                  <i className="bi bi-box-arrow-in-right"></i>
                  <span className="d-none d-sm-inline ms-1">Sign In</span>
                </Link>
              </li>
            )}
            <div className="dropdown">
              <span
                className=" text-nowrap cursor-pointer border px-1 py-1 rounded-2 click-animation d-block"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ cursor: "pointer" }}
              >
                <span className=" d-inline-flex flex-column justify-content-start">
                  <span className=" text-md fw-semibold">
                    <i className="bi bi-person"></i>
                    Hi, {user.name?.split(" ")[0]}{" "}
                  </span>
                  <small className=" text-sm text-muted">{user.role}</small>
                </span>
                <i className="bi bi-three-dots-vertical"></i>
              </span>
              <ul
                className="dropdown-menu dropdown-menu-end position-absolute mt-2 p-2"
                style={{ zIndex: 9999 }}
              >
                <li className="menu-item p-1">
                  <div
                    className="d-flex align-items-center gap-2"
                    onClick={() => history.push("/select-designation")}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-people"></i>
                    <span className="">Switch Roles</span>
                  </div>
                </li>
                <li className="menu-item p-1">
                  <div
                    className="d-flex align-items-center gap-2"
                    onClick={() => history.push(`/profile/${user.phone}`)}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-person-circle"></i>
                    <span>Profile</span>
                  </div>
                </li>
                <li className="menu-item p-1">
                  <div
                    className="d-flex align-items-center gap-2 text-danger fw-semibold"
                    onClick={logout}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-box-arrow-right"></i>
                    <span>Logout</span>
                  </div>
                </li>
                {/* <li className="menu-item p-1">
                <div
                  className="d-flex align-items-center gap-2"
                  onClick={handleStartTour}
                  style={{ cursor: "pointer" }}
                >
                  <i className="bi bi-question-circle"></i>
                  <span>Dashboard Tour</span>
                </div>
              </li> */}
              </ul>
            </div>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
